import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#8247E5",
      d: "M16.938 8.763c-.351-.2-.802-.2-1.203 0l-2.808 1.655-1.905 1.053-2.757 1.654c-.35.2-.802.2-1.203 0L4.906 11.82c-.35-.2-.601-.601-.601-1.052V8.262c0-.4.2-.802.601-1.053l2.156-1.253c.351-.2.802-.2 1.203 0l2.156 1.304c.35.2.601.601.601 1.052v1.655l1.905-1.103V7.159c0-.4-.2-.802-.601-1.052L8.316 3.75c-.352-.2-.803-.2-1.204 0l-4.11 2.407A1.1 1.1 0 0 0 2.4 7.159v4.712c0 .402.2.803.601 1.053l4.061 2.356c.351.2.802.2 1.203 0l2.757-1.604 1.905-1.103 2.758-1.604c.35-.2.802-.2 1.203 0l2.155 1.254c.351.2.602.601.602 1.052v2.507c0 .4-.2.802-.602 1.052l-2.105 1.254c-.351.2-.802.2-1.203 0l-2.156-1.254c-.35-.2-.602-.601-.602-1.052v-1.604l-1.905 1.102v1.655c0 .4.201.802.602 1.053l4.06 2.356c.351.2.803.2 1.204 0l4.06-2.357c.351-.2.602-.601.602-1.052v-4.763c0-.4-.2-.802-.602-1.052l-4.06-2.357Z"
    }, null, -1)
  ])))
}
export default { render: render }